<template>
  <v-container fluid>
    <UniversalTable
      :config="tableConfig.tableParams.value"
      :items="filteredAllResponsibilities"
      @onSearch="viewState.state.filters.searchText = $event"
      @onClick="viewState.state.filters.showFilterDialog = true"
      @removeFilter="viewState.removeFilters"
      @removeAllFilters="viewState.state.filters.values = []"
      :emptyObjectData="emptyObjectData"
    >
    </UniversalTable>
    <SearchModal
      :dialog="viewState.state.filters.showFilterDialog"
      @back="viewState.state.filters.showFilterDialog = false"
      @checkedItemsChanged="viewState.applyFilters"
      :clearSelection="viewState.state.filters.clearSelection"
      filterType="Employee Readiness"
      :filterGroups="viewState.state.filters.filterGroups"
      :statusOptions="[]"
      :modalWidth="800"
      :defaultSelected="viewState.state.filters.values"
    />
  </v-container>
</template>

<script setup>
import { computed, defineProps } from "vue";
import UniversalTable from "@components/UniversalTable/UniversalTable.vue";
import { useTableConfig } from "./composables/useTableConfig";
import { useViewState } from "./composables/useViewState";
import SearchModal from "@components/SearchBar/SearchModal.vue";

const tableConfig = useTableConfig();
const viewState = useViewState();
const emptyObjectData = {
  singular: "Responsibility",
  plural: "Responsibilities",
};
const props = defineProps({
  respDataSource: {
    type: Array,
    default: () => [],
  },
});
const dataStream = [
  {
    id: 1,
    name: "Responsibility Name",
    code: "#9999",
    checkpoint: {
      apprentice: 3,
      professional: 2,
      master: 4,
      coach: 3,
    },
    coach_badges: [
      {
        img: "https://cdn.vuetifyjs.com/images/john.jpg",
        firstName: "Ajay",
        lastName: "Rajput",
      },
      {
        img: require(`@components/assets/emp/emp2.png`),
        firstName: "James",
        lastName: "User",
      },
      {
        img: require(`@components/assets/emp/emp1.png`),
        firstName: "Devid",
        lastName: "User",
      },
      {
        img: "https://cdn.vuetifyjs.com/images/john.jpg",
        firstName: "Dan",
        lastName: "User",
      },
    ],
  },
  {
    id: 1,
    name: "Responsibility Name",
    code: "#9999",
    checkpoint: {
      apprentice: 3,
      professional: 2,
      master: 4,
      coach: 3,
    },
    coach_badges: [
      {
        img: "https://cdn.vuetifyjs.com/images/john.jpg",
        firstName: "Ajay",
        lastName: "Rajput",
      },
      {
        img: require(`@components/assets/emp/emp2.png`),
        firstName: "James",
        lastName: "User",
      },
      {
        img: require(`@components/assets/emp/emp1.png`),
        firstName: "Devid",
        lastName: "User",
      },
      {
        img: "https://cdn.vuetifyjs.com/images/john.jpg",
        firstName: "Dan",
        lastName: "User",
      },
    ],
  },
  {
    id: 1,
    name: "Responsibility Name",
    code: "#9999",
    checkpoint: {
      apprentice: 3,
      professional: 2,
      master: 4,
      coach: 3,
    },
    coach_badges: [
      {
        img: "https://cdn.vuetifyjs.com/images/john.jpg",
        firstName: "Ajay",
        lastName: "Rajput",
      },
      {
        img: require(`@components/assets/emp/emp2.png`),
        firstName: "James",
        lastName: "User",
      },
      {
        img: require(`@components/assets/emp/emp1.png`),
        firstName: "Devid",
        lastName: "User",
      },
      {
        img: "https://cdn.vuetifyjs.com/images/john.jpg",
        firstName: "Dan",
        lastName: "User",
      },
    ],
  },
  {
    id: 1,
    name: "Responsibility Name",
    code: "#9999",
    checkpoint: {
      apprentice: 3,
      professional: 2,
      master: 4,
      coach: 3,
    },
    coach_badges: [
      {
        img: "https://cdn.vuetifyjs.com/images/john.jpg",
        firstName: "Ajay",
        lastName: "Rajput",
      },
      {
        img: require(`@components/assets/emp/emp2.png`),
        firstName: "James",
        lastName: "User",
      },
      {
        img: require(`@components/assets/emp/emp1.png`),
        firstName: "Devid",
        lastName: "User",
      },
      {
        img: "https://cdn.vuetifyjs.com/images/john.jpg",
        firstName: "Dan",
        lastName: "User",
      },
    ],
  },
  {
    id: 1,
    name: "Responsibility Name",
    code: "#9999",
    checkpoint: {
      apprentice: 3,
      professional: 2,
      master: 4,
      coach: 3,
    },
    coach_badges: [
      {
        img: "https://cdn.vuetifyjs.com/images/john.jpg",
        firstName: "Ajay",
        lastName: "Rajput",
      },
      {
        img: require(`@components/assets/emp/emp2.png`),
        firstName: "James",
        lastName: "User",
      },
      {
        img: require(`@components/assets/emp/emp1.png`),
        firstName: "Devid",
        lastName: "User",
      },
      {
        img: "https://cdn.vuetifyjs.com/images/john.jpg",
        firstName: "Dan",
        lastName: "User",
      },
    ],
  },
  {
    id: 1,
    name: "Responsibility Name",
    code: "#9999",
    checkpoint: {
      apprentice: 3,
      professional: 2,
      master: 4,
      coach: 3,
    },
    coach_badges: [
      {
        img: "https://cdn.vuetifyjs.com/images/john.jpg",
        firstName: "Ajay",
        lastName: "Rajput",
      },
      {
        img: require(`@components/assets/emp/emp2.png`),
        firstName: "James",
        lastName: "User",
      },
      {
        img: require(`@components/assets/emp/emp1.png`),
        firstName: "Devid",
        lastName: "User",
      },
      {
        img: "https://cdn.vuetifyjs.com/images/john.jpg",
        firstName: "Dan",
        lastName: "User",
      },
    ],
  },
  {
    id: 1,
    name: "Responsibility Name",
    code: "#9999",
    checkpoint: {
      apprentice: 3,
      professional: 2,
      master: 4,
      coach: 3,
    },
    coach_badges: [
      {
        img: "https://cdn.vuetifyjs.com/images/john.jpg",
        firstName: "Ajay",
        lastName: "Rajput",
      },
      {
        img: require(`@components/assets/emp/emp2.png`),
        firstName: "James",
        lastName: "User",
      },
      {
        img: require(`@components/assets/emp/emp1.png`),
        firstName: "Devid",
        lastName: "User",
      },
      {
        img: "https://cdn.vuetifyjs.com/images/john.jpg",
        firstName: "Dan",
        lastName: "User",
      },
    ],
  },
  {
    id: 1,
    name: "Responsibility Name",
    code: "#9999",
    checkpoint: {
      apprentice: 3,
      professional: 2,
      master: 4,
      coach: 3,
    },
    coach_badges: [
      {
        img: "https://cdn.vuetifyjs.com/images/john.jpg",
        firstName: "Ajay",
        lastName: "Rajput",
      },
      {
        img: require(`@components/assets/emp/emp2.png`),
        firstName: "James",
        lastName: "User",
      },
      {
        img: require(`@components/assets/emp/emp1.png`),
        firstName: "Devid",
        lastName: "User",
      },
      {
        img: "https://cdn.vuetifyjs.com/images/john.jpg",
        firstName: "Dan",
        lastName: "User",
      },
    ],
  },
  {
    id: 1,
    name: "Responsibility Name",
    code: "#9999",
    checkpoint: {
      apprentice: 3,
      professional: 2,
      master: 4,
      coach: 3,
    },
    coach_badges: [
      {
        img: "https://cdn.vuetifyjs.com/images/john.jpg",
        firstName: "Ajay",
        lastName: "Rajput",
      },
      {
        img: require(`@components/assets/emp/emp2.png`),
        firstName: "James",
        lastName: "User",
      },
      {
        img: require(`@components/assets/emp/emp1.png`),
        firstName: "Devid",
        lastName: "User",
      },
      {
        img: "https://cdn.vuetifyjs.com/images/john.jpg",
        firstName: "Dan",
        lastName: "User",
      },
    ],
  },
  {
    id: 1,
    name: "Responsibility Name",
    code: "#9999",
    checkpoint: {
      apprentice: 3,
      professional: 2,
      master: 4,
      coach: 3,
    },
    coach_badges: [
      {
        img: "https://cdn.vuetifyjs.com/images/john.jpg",
        firstName: "Ajay",
        lastName: "Rajput",
      },
      {
        img: require(`@components/assets/emp/emp2.png`),
        firstName: "James",
        lastName: "User",
      },
      {
        img: require(`@components/assets/emp/emp1.png`),
        firstName: "Devid",
        lastName: "User",
      },
      {
        img: "https://cdn.vuetifyjs.com/images/john.jpg",
        firstName: "Dan",
        lastName: "User",
      },
    ],
  },
  {
    id: 1,
    name: "Responsibility Name",
    code: "#9999",
    checkpoint: {
      apprentice: 3,
      professional: 2,
      master: 4,
      coach: 3,
    },
    coach_badges: [
      {
        img: "https://cdn.vuetifyjs.com/images/john.jpg",
        firstName: "Ajay",
        lastName: "Rajput",
      },
      {
        img: require(`@components/assets/emp/emp2.png`),
        firstName: "James",
        lastName: "User",
      },
      {
        img: require(`@components/assets/emp/emp1.png`),
        firstName: "Devid",
        lastName: "User",
      },
      {
        img: "https://cdn.vuetifyjs.com/images/john.jpg",
        firstName: "Dan",
        lastName: "User",
      },
    ],
  },
  {
    id: 1,
    name: "Responsibility Name",
    code: "#9999",
    checkpoint: {
      apprentice: 3,
      professional: 2,
      master: 4,
      coach: 3,
    },
    coach_badges: [
      {
        img: "https://cdn.vuetifyjs.com/images/john.jpg",
        firstName: "Ajay",
        lastName: "Rajput",
      },
      {
        img: require(`@components/assets/emp/emp2.png`),
        firstName: "James",
        lastName: "User",
      },
      {
        img: require(`@components/assets/emp/emp1.png`),
        firstName: "Devid",
        lastName: "User",
      },
      {
        img: "https://cdn.vuetifyjs.com/images/john.jpg",
        firstName: "Dan",
        lastName: "User",
      },
    ],
  },
  {
    id: 1,
    name: "Responsibility Name",
    code: "#9999",
    checkpoint: {
      apprentice: 3,
      professional: 2,
      master: 4,
      coach: 3,
    },
    coach_badges: [
      {
        img: "https://cdn.vuetifyjs.com/images/john.jpg",
        firstName: "Ajay",
        lastName: "Rajput",
      },
      {
        img: require(`@components/assets/emp/emp2.png`),
        firstName: "James",
        lastName: "User",
      },
      {
        img: require(`@components/assets/emp/emp1.png`),
        firstName: "Devid",
        lastName: "User",
      },
      {
        img: "https://cdn.vuetifyjs.com/images/john.jpg",
        firstName: "Dan",
        lastName: "User",
      },
    ],
  },
  {
    id: 1,
    name: "Responsibility Name",
    code: "#9999",
    checkpoint: {
      apprentice: 3,
      professional: 2,
      master: 4,
      coach: 3,
    },
    coach_badges: [
      {
        img: "https://cdn.vuetifyjs.com/images/john.jpg",
        firstName: "Ajay",
        lastName: "Rajput",
      },
      {
        img: require(`@components/assets/emp/emp2.png`),
        firstName: "James",
        lastName: "User",
      },
      {
        img: require(`@components/assets/emp/emp1.png`),
        firstName: "Devid",
        lastName: "User",
      },
      {
        img: "https://cdn.vuetifyjs.com/images/john.jpg",
        firstName: "Dan",
        lastName: "User",
      },
    ],
  },
  {
    id: 1,
    name: "Responsibility Name",
    code: "#9999",
    checkpoint: {
      apprentice: 3,
      professional: 2,
      master: 4,
      coach: 3,
    },
    coach_badges: [
      {
        img: "https://cdn.vuetifyjs.com/images/john.jpg",
        firstName: "Ajay",
        lastName: "Rajput",
      },
      {
        img: require(`@components/assets/emp/emp2.png`),
        firstName: "James",
        lastName: "User",
      },
      {
        img: require(`@components/assets/emp/emp1.png`),
        firstName: "Devid",
        lastName: "User",
      },
      {
        img: "https://cdn.vuetifyjs.com/images/john.jpg",
        firstName: "Dan",
        lastName: "User",
      },
    ],
  },
  {
    id: 1,
    name: "Responsibility Name",
    code: "#9999",
    checkpoint: {
      apprentice: 3,
      professional: 2,
      master: 4,
      coach: 3,
    },
    coach_badges: [
      {
        img: "https://cdn.vuetifyjs.com/images/john.jpg",
        firstName: "Ajay",
        lastName: "Rajput",
      },
      {
        img: require(`@components/assets/emp/emp2.png`),
        firstName: "James",
        lastName: "User",
      },
      {
        img: require(`@components/assets/emp/emp1.png`),
        firstName: "Devid",
        lastName: "User",
      },
      {
        img: "https://cdn.vuetifyjs.com/images/john.jpg",
        firstName: "Dan",
        lastName: "User",
      },
    ],
  },
  {
    id: 1,
    name: "Responsibility Name",
    code: "#9999",
    checkpoint: {
      apprentice: 3,
      professional: 2,
      master: 4,
      coach: 3,
    },
    coach_badges: [
      {
        img: "https://cdn.vuetifyjs.com/images/john.jpg",
        firstName: "Ajay",
        lastName: "Rajput",
      },
      {
        img: require(`@components/assets/emp/emp2.png`),
        firstName: "James",
        lastName: "User",
      },
      {
        img: require(`@components/assets/emp/emp1.png`),
        firstName: "Devid",
        lastName: "User",
      },
      {
        img: "https://cdn.vuetifyjs.com/images/john.jpg",
        firstName: "Dan",
        lastName: "User",
      },
    ],
  },
  {
    id: 1,
    name: "Responsibility Name",
    code: "#9999",
    checkpoint: {
      apprentice: 3,
      professional: 2,
      master: 4,
      coach: 3,
    },
    coach_badges: [
      {
        img: "https://cdn.vuetifyjs.com/images/john.jpg",
        firstName: "Ajay",
        lastName: "Rajput",
      },
      {
        img: require(`@components/assets/emp/emp2.png`),
        firstName: "James",
        lastName: "User",
      },
      {
        img: require(`@components/assets/emp/emp1.png`),
        firstName: "Devid",
        lastName: "User",
      },
      {
        img: "https://cdn.vuetifyjs.com/images/john.jpg",
        firstName: "Dan",
        lastName: "User",
      },
    ],
  },
  {
    id: 1,
    name: "Responsibility Name",
    code: "#9999",
    checkpoint: {
      apprentice: 3,
      professional: 2,
      master: 4,
      coach: 3,
    },
    coach_badges: [
      {
        img: "https://cdn.vuetifyjs.com/images/john.jpg",
        firstName: "Ajay",
        lastName: "Rajput",
      },
      {
        img: require(`@components/assets/emp/emp2.png`),
        firstName: "James",
        lastName: "User",
      },
      {
        img: require(`@components/assets/emp/emp1.png`),
        firstName: "Devid",
        lastName: "User",
      },
      {
        img: "https://cdn.vuetifyjs.com/images/john.jpg",
        firstName: "Dan",
        lastName: "User",
      },
    ],
  },
  {
    id: 1,
    name: "Responsibility Name",
    code: "#9999",
    checkpoint: {
      apprentice: 3,
      professional: 2,
      master: 4,
      coach: 3,
    },
    coach_badges: [
      {
        img: "https://cdn.vuetifyjs.com/images/john.jpg",
        firstName: "Ajay",
        lastName: "Rajput",
      },
      {
        img: require(`@components/assets/emp/emp2.png`),
        firstName: "James",
        lastName: "User",
      },
      {
        img: require(`@components/assets/emp/emp1.png`),
        firstName: "Devid",
        lastName: "User",
      },
      {
        img: "https://cdn.vuetifyjs.com/images/john.jpg",
        firstName: "Dan",
        lastName: "User",
      },
    ],
  },
  {
    id: 1,
    name: "Responsibility Name",
    code: "#9999",
    checkpoint: {
      apprentice: 3,
      professional: 2,
      master: 4,
      coach: 3,
    },
    coach_badges: [
      {
        img: "https://cdn.vuetifyjs.com/images/john.jpg",
        firstName: "Ajay",
        lastName: "Rajput",
      },
      {
        img: require(`@components/assets/emp/emp2.png`),
        firstName: "James",
        lastName: "User",
      },
      {
        img: require(`@components/assets/emp/emp1.png`),
        firstName: "Devid",
        lastName: "User",
      },
      {
        img: "https://cdn.vuetifyjs.com/images/john.jpg",
        firstName: "Dan",
        lastName: "User",
      },
    ],
  },
  {
    id: 1,
    name: "Responsibility Name",
    code: "#9999",
    checkpoint: {
      apprentice: 3,
      professional: 2,
      master: 4,
      coach: 3,
    },
    coach_badges: [
      {
        img: "https://cdn.vuetifyjs.com/images/john.jpg",
        firstName: "Ajay",
        lastName: "Rajput",
      },
      {
        img: require(`@components/assets/emp/emp2.png`),
        firstName: "James",
        lastName: "User",
      },
      {
        img: require(`@components/assets/emp/emp1.png`),
        firstName: "Devid",
        lastName: "User",
      },
      {
        img: "https://cdn.vuetifyjs.com/images/john.jpg",
        firstName: "Dan",
        lastName: "User",
      },
    ],
  },
];

const filteredAllResponsibilities = computed(() => {
  let allResponsibilities = props?.respDataSource || dataStream;

  if (
    viewState.state.filters.searchText &&
    viewState.state.filters.searchText.length > 0
  ) {
    const searchText = viewState.state.filters.searchText.toLowerCase();

    allResponsibilities = allResponsibilities.filter((el) => {
      const fullName = `${el.name} ${el.code}`.toLowerCase();
      return (
        fullName.includes(searchText) ||
        el.name.toLowerCase().includes(searchText)
      );
    });
  }

  allResponsibilities = allResponsibilities.sort((a, b) => {
    const nameA = a?.name?.toLowerCase() || "";
    const nameB = b?.name?.toLowerCase() || "";

    if (nameA < nameB) return -1;
    if (nameA > nameB) return 1;
    return 0;
  });
  return allResponsibilities;
});
</script>

<style scoped>
.icon-container {
  cursor: pointer;
}
</style>
